import React from 'react';
import { renderToString } from 'react-dom/server';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import getDeliveryDetails from 'store/product/selector/getDeliveryDetails';

import cn from 'classnames';
import styles from './ProductionCountry.module.scss';
import formatPrice from '../../../utils/price/formatPrice';
import { IMAGES_PATH } from '../../../utils/settings';

const ProductionCountry = () => {
  const { t } = useTranslation();
  const deliveryDetails = useSelector(getDeliveryDetails);
  if (!deliveryDetails || !deliveryDetails.products || !deliveryDetails.products.length) {
    return null;
  }

  if (!deliveryDetails.products[0].localProduction) {
    return null;
  }

  const getCountryCode = () =>
    deliveryDetails?.products && deliveryDetails?.products[0]?.productionCountryId
      ? deliveryDetails?.products[0]?.productionCountryId
      : null;
  const shipmentPrice =
    deliveryDetails.products &&
    deliveryDetails.products[0] &&
    deliveryDetails.products[0].prices &&
    deliveryDetails.products[0].prices[0]
      ? deliveryDetails.products[0].prices[0]
      : undefined;

  if (!shipmentPrice) {
    return null;
  }

  const getPrice = () => shipmentPrice;
  const getPriceFormat = () => (deliveryDetails?.priceFormat ? deliveryDetails?.priceFormat : '-');
  const getPriceCurrencyId = () => (deliveryDetails?.currencyId ? deliveryDetails?.currencyId : '-');

  const getFlagURL = (code: string) => `${IMAGES_PATH}flags/${code.toLowerCase()}.svg`;
  const getCountryName = (code: string) => t(`country_name_${code.toUpperCase()}`);

  const getPriceRendered = () => {
    const price = getPrice();
    const priceFormat = getPriceFormat();
    const currencyId = getPriceCurrencyId();

    if (!price || !price.p || !price.pi) {
      return <span>-</span>;
    }

    return (
      <span>
        {price && priceFormat && currencyId && (
          <span className={styles.price}>
            <span
              className={cn({
                [styles.crossed]: price.pi !== price.p,
              })}
            >
              {formatPrice(price.pi, priceFormat, currencyId)}
            </span>
            {price.pi !== price.p ? (
              <span
                className={cn({
                  [styles.red]: price.pi !== price.p,
                })}
              >
                {formatPrice(price.p, priceFormat, currencyId)}
              </span>
            ) : null}
          </span>
        )}
      </span>
    );
  };

  const countryCode = getCountryCode() as any as string;
  if (!countryCode) {
    return <div />;
  }

  return (
    <div className={styles.productionCountry}>
      <div className={styles.flag}>
        <img src={getFlagURL(countryCode)} alt={getCountryName(countryCode)} />
      </div>
      <div className={styles.text}>
        <span
          className={styles.productionDetails}
          dangerouslySetInnerHTML={{
            __html: t('txt_production_country', {
              country: getCountryName(countryCode),
              price: renderToString(getPriceRendered()),
              days: '3-5',
            }),
          }}
        />
        <a href="#deliveryOptions">({t('txt_production_country_more_options')})</a>
      </div>
    </div>
  );
};

export default ProductionCountry;
